import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { Viewer } from '../../entities/viewer-mapping.entity';
import { GetViewerByExtension } from '../../helper/extension-to-viewer.helper';
import { EmlViewerComponent } from '../eml-viewer/eml-viewer.component';
import { ImageViewerComponent } from '../image-viewer/image-viewer.component';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { VideoViewerComponent } from '../video-viewer/video-viewer.component';
import { WarcViewerComponent } from '../warc-viewer/warc-viewer.component';

@Component({
    selector: 'sh-viewer',
    templateUrl: './viewer.component.html',
    styleUrls: ['./viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ImageViewerComponent,
        PdfViewerComponent,
        VideoViewerComponent,
        EmlViewerComponent,
        WarcViewerComponent,
        TranslateModule
    ]
})
export class ViewerComponent {
    public readonly viewers: typeof Viewer = Viewer;

    safeUrl = computed(() => this.domSanitizer.bypassSecurityTrustUrl(this.blobUrl()));
    viewer = computed(() => GetViewerByExtension(this.extension()));

    blobUrl = input<string>('');
    originalSourceUrl = input<string>('');

    extension = input<string>('');

    toastId = input<number>();

    constructor(private readonly domSanitizer: DomSanitizer) {}
}
